import { Button } from "primereact/button";
import { Route } from 'react-router-dom'

const ButtonAvancarQuestionario = ({ etapa, handleAvancarEtapaGrupoQuestao, handleSetEtapaQuestionario, handleEnviarRespostas }) => {

    let buttonAvancar;

    if (etapa === "I") {
        buttonAvancar = (
            <Button label="AVANÇAR" icon="pi pi-arrow-right" onClick={() => { handleSetEtapaQuestionario(+1) }} />
        );

    } else if (etapa === "Q") {
        buttonAvancar = (
            <Button label="AVANÇAR" icon="pi pi-arrow-right" onClick={() => { handleAvancarEtapaGrupoQuestao(+1) }} />
        );

    } else {
        buttonAvancar = (
            <Route render={(props) => (
                <Button label="FINALIZAR" icon="pi pi-arrow-right" onClick={() => { handleEnviarRespostas(props) }} />
            )} />
        );
    }

    return (
        <div>
            {buttonAvancar}
        </div>
    )

}

export default ButtonAvancarQuestionario